export default __webpack_public_path__ + "static/media/amazon.b63df6f8.webp";